<mat-drawer-container class="drawer-container" (backdropClick)="closeDrawer()">
  <mat-drawer #drawer position="end" mode="over" class="drawer" [ngStyle]="{ width: drawerConfig()?.width }" [autoFocus]="true">
    <app-mat-drawer-wrapper [config]="drawerConfig()"></app-mat-drawer-wrapper>
  </mat-drawer>
  <mat-drawer-content class="drawer-content">
    <div class="primary-router-outlet">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
